module.exports = "https://trybtryb-legacy.web.app/img/rounded-transparent-mobile.b6b3f7e8.svg";